import React, { createContext, useContext, useEffect, useState } from "react";

const PresentationContext = createContext(null);

export function PresentationProvider({ children }) {
  const [presenting, setPresenting] = useState(false);

  useEffect(() => {
    if (presenting) {
      document.body.classList.add("ag-presenting");
    } else {
      document.body.classList.remove("ag-presenting");
    }
  }, [presenting]);

  return (
    <PresentationContext.Provider value={{ presenting, setPresenting }}>
      {children}
    </PresentationContext.Provider>
  );
}

export function usePresentation() {
  const ctx = useContext(PresentationContext);
  if (!ctx) throw new Error("usePresentation must be used within PresentationProvider");
  return ctx;
}
